import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";
import { MainMenu } from "./MainMenu";
import { AppsMenu } from "./AppsMenu";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { User, LogOut, Settings, Code2, History, Info } from "lucide-react";

export function Header({ compact = false }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isAuthed = user && user !== false;

  return (
    <header className={`w-full border-b border-[var(--omni-border)] bg-white ${compact ? "py-3" : "py-4"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-4">
        <Logo size={compact ? "sm" : "md"} />
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <Link to="/developers" data-testid="nav-developers" className="text-gray-600 hover:text-black transition">Développeurs</Link>
          <Link to="/about" data-testid="nav-about" className="text-gray-600 hover:text-black transition">À propos</Link>
        </nav>
        <div className="flex items-center gap-2">
          {!isAuthed && (
            <>
              <Button asChild variant="ghost" size="sm" data-testid="nav-login">
                <Link to="/login" state={{ from: loc.pathname }}>Connexion</Link>
              </Button>
              <Button asChild size="sm" data-testid="nav-register" className="bg-[var(--omni-accent)] hover:bg-[var(--omni-accent-hover)] text-white rounded-full">
                <Link to="/register">Créer un compte</Link>
              </Button>
            </>
          )}
          {isAuthed && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  data-testid="user-menu-trigger"
                  className="flex items-center gap-2 rounded-full border border-[var(--omni-border)] pl-2 pr-3 py-1.5 hover:border-black transition"
                >
                  <div className="w-7 h-7 rounded-full bg-[var(--omni-accent)] text-white flex items-center justify-center text-sm font-bold">
                    {(user.name || user.email)[0]?.toUpperCase()}
                  </div>
                  <span className="text-sm font-medium hidden sm:inline">{user.name || "Compte"}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel className="font-normal">
                  <div className="text-xs text-gray-500">Connecté en tant que</div>
                  <div className="font-medium truncate">{user.email}</div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild data-testid="menu-profile">
                  <Link to="/profile"><User className="mr-2 h-4 w-4" />Profil</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild data-testid="menu-history">
                  <Link to="/profile#history"><History className="mr-2 h-4 w-4" />Historique</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild data-testid="menu-developers">
                  <Link to="/developers"><Code2 className="mr-2 h-4 w-4" />Développeurs</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild data-testid="menu-settings">
                  <Link to="/settings"><Settings className="mr-2 h-4 w-4" />Paramètres</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild data-testid="menu-about">
                  <Link to="/about"><Info className="mr-2 h-4 w-4" />À propos</Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={logout} data-testid="menu-logout">
                  <LogOut className="mr-2 h-4 w-4" />Déconnexion
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
          <AppsMenu />
          <MainMenu />
        </div>
      </div>
    </header>
  );
}
